export const FILTER_DATE = 'date';
export const DATE_FILTER_ARR = [FILTER_DATE];